import React, {useState, useEffect, useCallback} from 'react'
import Editor from "rich-markdown-editor";

import {debounce} from '../Editor';

export const Markdown = (props) => {
    const [isEditable, setIsEditable] = useState(true);

    let content = props.payload?props.payload:'';

    const handleChange = useCallback(
        debounce((valueFunction) => {
            props.onChange(valueFunction());
        }, 1000),
        []
    );

    return (
        <Editor
            //value={content}
            id={props.id}
            readOnly={props.readonly}
            defaultValue={content}
            onChange={(value) => {
                handleChange(value)
                /*if(value().split('\n').length > 1){
                    console.log(value().split('\n'), 'Set not editable');
                    setContent(value().split('\n')[0]);
                    setIsEditable(false);
                }*/
            }}
            onFocus={(e) => {
                //setIsEditable(true);
            }}
        />
    )

    /*return (
        <div style={{
            fontSize: '1em'
        }}>
            <div style={{
                color: '#DDDDDD',
                position: 'absolute',
                pointerEvents: 'none',
                lineHeight: '1em',
                display: content.length?'none':'block'
            }}>Schreiben Sie Ihren Beitrag...</div>
            <div style={{
                minHeight: '1em',
                outline: 'none',
                lineHeight: '1em'
            }} contenteditable={isEditable?'true':null} html={content} onInput={e => setContent(e.currentTarget.textContent)}>
            </div>
        </div>
    )*/
}